export class SharedUtils {

    public static getDeviceInitials(name: String): String {
        if (name.lastIndexOf(' ') !== -1) {
            if (name !== '') {
                const str = `${name.charAt(0)}${name.charAt(name.lastIndexOf(' ') + 1)}`;
                return str.toUpperCase();
            } else {
                return name.toUpperCase();
            }
        } else if (name.lastIndexOf(':') !== -1) {
            if (name !== '') {
                const str = `${name.charAt(0)}${name.charAt(name.lastIndexOf(':') + 1)}`;
                return str.toUpperCase();
            } else {
                return name.toUpperCase();
            }
        } else {
            return name.charAt(0).toUpperCase() + name.charAt(1).toUpperCase();
        }
    }

    public static getEnergy(watts: number): number {
        if (watts === undefined || watts === null) { return 0; }
        if (watts >= 1000) {
            return Number((watts / 1000).toFixed(2));
        } else {
            return watts;
        }
    }

    public static getEnergyUnitH(watts: number): string {
        if (watts === undefined || watts === null || watts < 1000) {
            return 'Wh';
        } else {
            return 'kWh';
        }
    }

    public static getEnergyUnit(watts: number): string {
        if (watts === undefined || watts === null || watts < 1000) {
            return 'W';
        } else {
            return 'kW';
        }
    }

    public static isDaylightSavingsTime(): boolean {
        const today = new Date();
        const jan = new Date(today.getFullYear(), 0, 1);
        const jul = new Date(today.getFullYear(), 6, 1);
        const stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return today.getTimezoneOffset() < stdTimezoneOffset;
    }

    public static getBatteryIcon(val) {
        const percentage = Number(val);
        if (percentage > 85 && percentage <= 100) {
          return 'assets/img/icons/ic_battery_full.svg';
        } else if (percentage >= 75 && percentage <= 85) {
          return 'assets/img/icons/ic_battery_75.svg';
        } else if (percentage <= 75 && percentage > 50) {
          return 'assets/img/icons/ic_battery_50.svg';
        } else if (percentage <= 50 && percentage > 25) {
          return 'assets/img/icons/ic_battery_25.svg';
        } else if ( percentage <= 25 && percentage >= 1) {
          return 'assets/img/icons/icon-low-battery.svg';
        } else if (percentage === 0) {
          return 'assets/img/icons/ic_battery_empty.svg';
        }
      }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.utils.ts